'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _spauiDecorate = require('@tencent/spaui-decorate');

var _spauiDecorate2 = _interopRequireDefault(_spauiDecorate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Component) {
    if (typeof Component !== 'undefined' && Component) {
        Component.decorate = function () {
            return new _spauiDecorate2.default(Component);
        };
    }
    return Component;
}; /**
    * @fileOverview 使用spaui-decorate默认给组件带上.decorate的方法
    * @author kirkzheng
    */